import { useTheme } from '../contexts/ThemeContext';
import ProfileMenu from './ProfileMenu';
import { Bell, Sun, Moon } from 'lucide-react';

export default function Header() {
  const { theme, toggleTheme } = useTheme();

  return (
    <header
      className="h-16 flex items-center justify-between px-6 border-b"
      style={{
        backgroundColor: 'var(--background-card)',
        borderColor: 'var(--border-color)',
      }}
    >
      {/* 左側: パンくずなど */}
      <div className="flex items-center gap-4">
        {/* 必要に応じてパンくずを追加 */}
      </div>

      {/* 右側: テーマ切替、通知、プロフィール */}
      <div className="flex items-center gap-3">
        {/* テーマ切替 */}
        <button
          onClick={toggleTheme}
          className="p-2 rounded-lg transition-colors"
          style={{ color: 'var(--text-secondary)' }}
          title={theme === 'light' ? 'ダークモードに切替' : 'ライトモードに切替'}
        >
          {theme === 'light' ? <Moon size={20} /> : <Sun size={20} />}
        </button>

        {/* 通知 */}
        <button
          className="p-2 rounded-lg transition-colors relative"
          style={{ color: 'var(--text-secondary)' }}
          title="通知"
        >
          <Bell size={20} />
          {/* 未読バッジ（例） */}
          <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full"></span>
        </button>

        {/* プロフィールメニュー */}
        <ProfileMenu />
      </div>
    </header>
  );
}

